<script setup>
import MultiSelect from 'primevue/multiselect'

const model = defineModel()
const props = defineProps({
  title: {
    type: String,
    required: true
  },
  options: {
    type: Array,
    required: true
  },
  optionLabel: {
    type: String,
    default: 'label'
  },
  optionValue: {
    type: String,
    default: 'value'
  },
  multiple: {
    type: Boolean,
    default: false
  },
  filter: {
    type: Boolean,
    default: false
  },
  emptyFilterMessage: {
    type: String,
    default: 'No se encontraron resultados'
  },
  emptySelectionMessage: {
    type: String,
    default: 'No hay selección'
  },
  emptyMessage: {
    type: String,
    default: 'No hay opciones disponibles'
  },
  showToggleAll: {
    type: Boolean,
    default: false
  }
})

const mustShowBlock = computed(() => {
  return props.options && props.options.filter(item => !!item?.[props.optionLabel]).length > 0
})
</script>

<template>
  <MultiSelect
    v-if="mustShowBlock"
    v-model="model"
    :options="props.options"
    :optionLabel="props.optionLabel"
    :optionValue="props.optionValue"
    display="chip"
    :filter="props.filter"
    :showToggleAll="props.showToggleAll"
    :placeholder="props.title"
    class="w-full sm:w-auto"
    :empty-selection-message="props.emptySelectionMessage"
    :empty-filter-message="props.emptyFilterMessage"
    :empty-message="props.emptyMessage"
  />
</template>
